module.exports = __webpack_public_path__ + "static/media/apply-avax-mobile.01c16d92.png";